import { documentIcon } from '../document-icon';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ElementRef,
  ChangeDetectorRef,
  TemplateRef,
  AfterViewChecked,
  OnDestroy
} from '@angular/core';
import { EcplTreeData } from './intefaces/ecpl-tree-data';
import { KEYS } from './tree-shim/tree-shims';

// Compatibility aliases / shims for previously used circlon types
type ITreeOptions = any;
type TreeNode = any;
type TreeModel = any;
// Provide a minimal TREE_ACTIONS placeholder so existing references compile.
const TREE_ACTIONS: any = {};
import * as _ from 'lodash';
import { ContextMenu } from 'primeng/contextmenu';
import { MenuItem } from 'primeng/api';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleModel } from 'src/app/shared/ecpl-article-viewer/interfaces';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { ChecklistModel } from 'src/app/shared/ecpl-checklist-viewer/ecpl-checklist-viewer.model';
import { BusinessServices } from './../../kuba/businesses/services/business.services';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FeatureKey } from 'src/app/_models';
import { UUID } from 'angular2-uuid';
import { HelperV2Service } from '../../_services/helper-v2.service';
import { DragDropService } from './drag-drop.service';
import { DragAutoScrollService } from './drag-auto-scroll.service';
import { TreeDragDropService } from 'primeng/api';
import { treeNodeKey } from './tree-node-key';
@Component({
  selector: 'app-ecpl-document-tree',
  templateUrl: './ecpl-document-tree.component.html',
  styleUrls: ['./ecpl-document-tree.component.scss'],
  standalone: false
})
export class EcplDocumentTreeComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() treeId: string;
  @Input() ecplTreeCheckbox: boolean;
  @Input() addFromManuals: boolean;
  @Input() ecplActiveNode: any;
  @Input() ecplApiResponse: string;
  @Input() adminUsers: any[];
  @Input() ecplTreeData: EcplTreeData[];
  @Input() isAdminManual: boolean;
  @Input() allowDrop: boolean;
  @Input() allowDrag: boolean;
  @Input() businessMode: string;
  @Input() treeType: string;
  @Input() isCopyMode: boolean = false; // Skip permission validation for copy between different trees
  /** Expand the first-level folders when the tree is first shown. Sub-folders stay collapsed. */
  @Input() expandRootFolders: boolean = false;
  @Output() ecplNodeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild('ecplTree', { static: false }) treeComponent: any;
  @ViewChild('hiddenAction', { static: false }) hiddenAction: ElementRef;
  @ViewChild('newFolderModal', { static: false })
  newFolderModal: TemplateRef<any>;
  @ViewChild('articleViewerRef', { static: false }) articleViewerRef: any;
  @ViewChild('checklistViewerRef', { static: false }) checklistViewerRef: any;
  @ViewChild('larViewerRef', { static: false }) larViewerRef: any;
  @Output() ecplNodeOptionsEvent: EventEmitter<any> = new EventEmitter();

  options: ITreeOptions;
  staticOptions: ITreeOptions;
  nodes: any = [];
  // PrimeNG tree nodes (converted from ecplTreeData)
  primeNodes: any[] = [];
  filteredPrimeNodes: any[] = [];
  filterText: string = '';
  selection: any = null;
  selectedNode: any = null;
  focusedNode: any = null;
  private _activeNode: any = null;
  /** Folder currently highlighted as a valid drop target. */
  dropTargetNode: any = null;
  skipRebuildOnChange: boolean = false;
  private treeModelShim: any;
  private isDestroyed: boolean = false;
  private statusChangeDebounceTimer: any = null;
  private labelToggleTimer: any = null;
  isCheckbox: boolean;
  file: any = null;
  previousFileId: any = null; // Track previous file to detect re-selection
  fileSelectionCounter: number = 0; // Incremented each file selection to force viewer re-open
  currentEventData: any;
  newFolderNode: EcplTreeData;
  bsModalRef: BsModalRef;
  bsConfig = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  bsModalTitle: string;
  userRole: string;
  applicationId: number;
  businessId: number;
  portalId: number;
  businessPortalId: number;
  featureId: any;
  get UserId() {
    return BaseServices.UserId;
  }
  projectId: number;
  isClientUser = false;
  //#region Context Menu
  @ViewChild('cm') public cm: ContextMenu;
  contextMenuItems: MenuItem[] = [];

  // Alert Dialog properties (replaces native browser alert)
  showAlertDialog: boolean = false;
  alertDialogMessage: string = '';

  contextMenuActions = [
    {
      html: (node: any | null) => this.translate.instant('NEW_ROOT_FOLDER'),
      action: (node: any | null) => 'AddNewRootFolder',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' ||
        ((node.data.isDefault === true ||
          (node.data.parentFolderId === 0 &&
            node.data.featureId === FeatureKey.ELECTRO)) &&
          node.data.documentType !== null)
    },
    {
      html: (node: any | null) => this.translate.instant('NEW_FOLDER'),
      action: (node: any | null) => 'AddNewSiblingFolder',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' &&
        node.data.parentFolderId !== 0 &&
        node.data.documentType !== null
    },
    {
      html: (node: any | null) => this.translate.instant('NEW_SUB_FOLDER'),
      action: (node: any | null) => 'AddNewFolder',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' && node.data.documentType !== null
    },
    {
      html: (node: any | null) => this.translate.instant('NEW_FILES'),
      action: (node: any | null) => 'AddFiles',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' &&
        node.data.documentType !== 'article' &&
        node.data.documentType !== 'checklist' &&
        node.data.documentType !== 'Laws/Regulation' &&
        node.data.documentType !== null &&
        node.data.documentType !== 'laws' &&
        node.data.documentType !== 'regulation' &&
        node.data.documentType !== 'videos' &&
        node.data.documentType !== 'archiveundercompletionfolder' &&
        node.data.documentType !== 'FS Checklist Under Completion' &&
        node.data.documentType !== 'fsundercompletion' &&
        node.data.documentType !== 'fscompleted'
    },
    {
      html: (node: any | null) => this.translate.instant('EDIT'),
      action: (node: any | null) => 'EditFile',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType !== 'article' &&
        node.data.documentType !== 'checklist' &&
        node.data.documentType !== 'regulation' &&
        node.data.documentType !== 'videos' &&
        node.data.documentType !== 'law' &&
        node.data.documentType !== null &&
        this.humanizeType(node.data.mimetype) === 'Document' &&
        node.data.documentType !== 'laws' &&
        node.data.documentType !== 'videos' &&
        node.data.documentType !== 'regulation' &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('COPY_FILE'),
      action: (node: any | null) => 'CopyFile',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType !== 'article' &&
        node.data.documentType !== 'checklist' &&
        node.data.documentType !== 'regulation' &&
        node.data.documentType !== 'videos' &&
        node.data.documentType !== 'law' &&
        node.data.documentType !== null &&
        node.data.documentType !== 'laws' &&
        node.data.documentType !== 'videos' &&
        node.data.documentType !== 'regulation' &&
        node.data.featureId !== FeatureKey.ELECTRO
    },
    {
      html: (node: any | null) => this.translate.instant('RENAME'),
      action: (node: any | null) => 'RenameFile',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType !== 'article' &&
        node.data.documentType !== 'checklist' &&
        node.data.documentType !== 'archiveundercompletion' &&
        node.data.documentType !== 'installationform' &&
        node.data.documentType !== 'undercompletioninstallationform' &&
        node.data.documentType !== 'videos' &&
        node.data.documentType !== 'regulation' &&
        node.data.documentType !== 'law' &&
        node.data.documentType !== null &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('DELETE'),
      action: (node: any | null) => 'DeleteFile',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType !== 'article' &&
        node.data.documentType !== 'checklist' &&
        node.data.documentType !== 'archiveundercompletion' &&
        node.data.documentType !== 'installationform' &&
        node.data.documentType !== 'undercompletioninstallationform' &&
        node.data.documentType !== 'videos' &&
        node.data.documentType !== 'regulation' &&
        node.data.documentType !== 'law' &&
        node.data.documentType !== null &&
        node.data.isEditable === true
    },

    {
      html: (node: any | null) => this.translate.instant('NEW_ARTICLE'),
      action: (node: any | null) => 'AddArticle',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' && node.data.documentType === 'article'
    },
    {
      html: (node: any | null) => this.translate.instant('EDIT'),
      action: (node: any | null) => 'EditArticle',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType === 'article' &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('RENAME'),
      action: (node: any | null) => 'RenameArticle',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType === 'article' &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('DELETE'),
      action: (node: any | null) => 'DeleteArticle',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType === 'article' &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('NEW_CHECKLIST'),
      action: (node: any | null) => 'AddChecklist',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' && node.data.documentType === 'checklist'
    },
    {
      html: (node: any | null) => this.translate.instant('EDIT'),
      action: (node: any | null) => 'EditChecklist',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType === 'checklist' &&
        node.data.featureId !== FeatureKey.ELECTRO &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('RENAME'),
      action: (node: any | null) => 'RenameChecklist',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType === 'checklist' &&
        node.data.featureId !== FeatureKey.ELECTRO &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('DELETE'),
      action: (node: any | null) => 'DeleteChecklist',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' &&
        node.data.documentType === 'checklist' &&
        node.data.featureId !== FeatureKey.ELECTRO &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('EDIT'),
      action: (node: any | null) => 'EditLaws',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' && node.data.documentType === 'law'
    },
    {
      html: (node: any | null) => this.translate.instant('EDIT'),
      action: (node: any | null) => 'EditRegulations',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'file' && node.data.documentType === 'regulation'
    },
    {
      html: (node: any | null) => this.translate.instant('RENAME'),
      action: (node: any | null) => 'RenameFolder',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' &&
        node.data.documentType !== null &&
        node.data.isDefault === false &&
        node.data.isEditable === true
    },
    {
      html: (node: any | null) => this.translate.instant('DELETE'),
      action: (node: any | null) => 'DeleteFolder',
      enabled: (node: any | null) => true,
      visible: (node: any | null) =>
        node.data.type === 'folder' &&
        node.data.documentType !== null &&
        node.data.isDefault === false &&
        node.data.isEditable === true
    }
  ];

  /**
   * Handles the context menu event for a tree node.
   * Builds the menu items dynamically based on visibility and enabled conditions.
   * @param event - The mouse event
   * @param node - The tree node that was right-clicked
   */
  onContextMenu(event: MouseEvent, node: any): void {
    // Only show context menu if ecplTreeCheckbox is enabled
    if (!this.ecplTreeCheckbox) {
      return;
    }

    event.preventDefault();
    this.selectedNode = node;

    // Build menu items from contextMenuActions
    this.contextMenuItems = this.contextMenuActions
      .filter(menu => menu.visible(node))
      .map(menu => ({
        label: menu.html(node),
        disabled: !menu.enabled(node),
        command: () => {
          const eventObj = { item: node };
          this.saveUpdateEvents(eventObj, menu.action(menu));
        }
      }));

    // Show the context menu
    if (this.contextMenuItems.length > 0) {
      this.cm.show(event);
    }
  }
  //#endregion

  // #Icons region
  /**
   * Returns a set of classes for the FontAwesome icon based on the node data.
   * The class to be applied is determined by the `status` and `isPermission` properties of the data.
   *
   * @param data - The node data containing properties `status` and `isPermission`.
   * @return An object representing the classes to be applied.
   *
   * - If `isPermission` is `false`(disabled from admin level), the classes `fa-eye-slash`, `darkgray-eye-slash`, and `text-disabled` are applied.
   * - If `isPermission` is `true`,
   *   - When `status` is `1` (checkbox checked), the classes `fa-eye` and `darkgray-eye` are applied.
   *   - When `status` is not `1(checkbox unchecked)`, the classes `fa-eye-slash` and `darkgray-eye-slash` are applied.
   */
  getIconClass(data: any) {
    if (!data.isPermission) {
      return {
        'fa-eye-slash': true,
        'darkgray-eye-slash': true,
        'text-disabled': true
      };
    }
    if (data.status === 1) {
      return { 'fa-eye': true, 'darkgray-eye': true };
    }
    return { 'fa-eye-slash': true, 'darkgray-eye-slash': true };
  }
  /**
   * Returns the tooltip text for the node based on its status.
   * The text is retrieved using the translation service.
   *
   * @param data - The node data containing the `status` property.
   * @return A string representing the tooltip text.
   *
   * - When `status` is `1`, the tooltip text is "CLICK_TO_HIDE".
   * - When `status` is `2`, the tooltip text is "CLICK_TO_SHOW".
   */
  getTooltipText(data: any) {
    if (data.status === 1) {
      return this.translate.instant('CLICK_TO_HIDE');
    }
    if (data.status === 2) {
      return this.translate.instant('CLICK_TO_SHOW');
    }
  }
  getFileIcon(node): string {
    return documentIcon(
      node.data.documentType,
      this.getFileExtensionFromMimeType(node.data.mimetype || '') || node.data.mimetype,
      node.data.isFolder,
      node.expanded,
      node.data.isDefault
        ? node.data.translateKey || node.data.originalFileName || node.data.filename
        : ''
    );
  }

  constructor(
    private dragDropService: DragDropService,
    private dragAutoScroll: DragAutoScrollService,
    private cdr: ChangeDetectorRef,
    private bsModalService: BsModalService,
    private businessService: BusinessServices,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private helperV2Service: HelperV2Service
  ) {
    this.newFolderNode = {
      filename: ''
    };
    this.userRole = BaseServices.UserRole;
    this.businessId = +this.route.snapshot.params['mBusinessId'];
    this.applicationId = BaseServices.ApplicationId;
    this.portalId = +this.route.snapshot.params['mPortalId'];
    this.projectId = this.route.snapshot.params['Id'];
    this.isClientUser =
      BaseServices.FeatureId == FeatureKey.CLIENT ||
      BaseServices.FeatureId == FeatureKey.CLIENT_CONTACT;
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
    this.featureId = workingModule.id;
    // ensure a fallback treeModel shim exists early so lifecycle hooks
    // can safely call treeComponent.treeModel.* before the ViewChild is set
    this.treeModelShim = this.createTreeModelShim();
    // pre-populate treeComponent with the shim so direct calls like
    // this.treeComponent.treeModel.update() won't throw during initialization
    this.treeComponent = { treeModel: this.treeModelShim } as any;
    this.dragAutoScroll.attach();
  }

  /**
   * Safe accessor for the tree model used throughout the component.
   * Returns the real ViewChild tree model when available, otherwise the shim.
   */
  private getTreeModel(): any {
    return (
      (this.treeComponent && this.treeComponent.treeModel) || this.treeModelShim
    );
  }

  saveFolderFile(eventData: any) {
    this.ecplActiveNode = this.getTreeModel().getActiveNode();
    switch (eventData.eventName) {
      case 'SaveLar':
        break;
      case 'AddNewRootFolder':
        if (this.newFolderNode.filename !== '') {
          this.newFolderNode.type = 'folder';
          this.newFolderNode.documentType = eventData.item.data.documentType;
          (this.newFolderNode as any).documentTypeId = (
            eventData.item.data as any
          ).documentTypeId; // Preserve clicked folder's typeId
          this.newFolderNode.isDefault = false;
          this.newFolderNode.isFolder = true;
          this.newFolderNode.status = 1;
          const archiveRoot =
            this.primeNodes && this.primeNodes[0] ? this.primeNodes[0] : null;
          eventData.parent = archiveRoot
            ? archiveRoot.data
            : eventData.item.data;
          eventData.sourceDocumentTypeId = (
            eventData.item.data as any
          ).documentTypeId;
          eventData.newNode = { ...this.newFolderNode };
          this.ecplNodeEvent.emit(eventData);
          this.bsModalRef.hide();
        }
        break;
      case 'AddNewSiblingFolder':
        if (this.newFolderNode.filename !== '') {
          this.newFolderNode.type = 'folder';
          this.newFolderNode.documentType = eventData.item.data.documentType;
          (this.newFolderNode as any).documentTypeId = (
            eventData.item.data as any
          ).documentTypeId; // Preserve clicked folder's typeId
          this.newFolderNode.isDefault = false;
          this.newFolderNode.isFolder = true;
          this.newFolderNode.status = 1;
          eventData.parent = eventData.item.parent
            ? eventData.item.parent.data
            : eventData.item.data;
          eventData.sourceDocumentTypeId = (
            eventData.item.data as any
          ).documentTypeId;
          eventData.newNode = { ...this.newFolderNode };
          this.ecplNodeEvent.emit(eventData);
          this.bsModalRef.hide();
        }
        break;
      case 'AddNewFolder':
        if (this.newFolderNode.filename !== '') {
          this.newFolderNode.type = 'folder';
          this.newFolderNode.documentType = eventData.item.data.documentType;
          (this.newFolderNode as any).documentTypeId = (
            eventData.item.data as any
          ).documentTypeId; // Preserve clicked folder's typeId
          this.newFolderNode.isDefault = false;
          this.newFolderNode.isFolder = true;
          this.newFolderNode.status = 1;
          eventData.parent = eventData.item.data;
          eventData.sourceDocumentTypeId = (
            eventData.item.data as any
          ).documentTypeId;
          eventData.newNode = { ...this.newFolderNode };
          this.bsModalRef.hide();
          this.ecplNodeEvent.emit(eventData);
        }
        break;

      case 'RenameFolder':
        if (this.newFolderNode.filename !== '') {
          eventData.item.data.filename = this.newFolderNode.filename;
          this.bsModalRef.hide();
          this.getTreeModel().update();
          this.ecplNodeEvent.emit(eventData);
        }
        break;
      case 'RenameFile':
        if (this.newFolderNode.filename !== '') {
          eventData.item.data.filename = this.newFolderNode.filename;
          this.bsModalRef.hide();
          this.getTreeModel().update();
          this.ecplNodeEvent.emit(eventData);
        }
        break;
      case 'RenameArticle':
        if (this.newFolderNode.filename !== '') {
          eventData.item.data.filename = this.newFolderNode.filename;
          this.bsModalRef.hide();
          this.getTreeModel().update();
          this.ecplNodeEvent.emit(eventData);
        }
        break;
      case 'RenameChecklist':
        if (this.newFolderNode.filename !== '') {
          eventData.item.data.filename = this.newFolderNode.filename;
          this.bsModalRef.hide();
          this.getTreeModel().update();
          this.ecplNodeEvent.emit(eventData);
        }
        break;
      case 'NewArticle':
        eventData.activeNodeId = this.currentEventData.item.data.nodeId;
        this.ecplNodeEvent.emit(eventData);
        break;

      case 'SaveArticle':
        this.ecplNodeEvent.emit(eventData);
        break;
      case 'NewChecklist':
        eventData.activeNodeId = this.currentEventData.item.data.nodeId;
        this.ecplNodeEvent.emit(eventData);
        break;
      case 'CopyChecklist':
        eventData.activeNodeId = this.currentEventData.item.data.nodeId;
        this.ecplNodeEvent.emit(eventData);
        break;

      case 'SaveChecklist':
        this.ecplNodeEvent.emit(eventData);
        break;
      case 'ShowOfficeFileSaveloader':
        this.ecplNodeEvent.emit(eventData);
        break;
      case 'CopyEditVersionDocument':
        this.ecplNodeEvent.emit(eventData);
        break;
      default:
        break;
    }
  }

  //#region Emitters
  sendTreeEvents(event: any) {
    if (event.eventName === 'activate') {
      if (event.node.data.type === 'file') {
        // Special handling: "under completion" items should navigate, not open viewer
        // Skip viewer logic for these document types - let parent component handle navigation
        const isUnderCompletionItem =
          event.node.data.documentType === 'archiveundercompletion' ||
          event.node.data.documentType === 'fsundercompletion';

        if (isUnderCompletionItem) {
          // Clear any open viewer and let the event pass through to parent for navigation
          this.file = null;
          this.cdr.detectChanges();
          this.ecplNodeEvent.emit(event);
          return; // Exit early - don't try to open viewer
        }

        // Only open viewer if openViewer flag is true (double-click)
        if (event.openViewer === true) {
          // Normal file handling for other document types
          const currentFileId = event.node.data.id || event.node.data.nodeId;
          const isFileSameAsLast = currentFileId === this.previousFileId;

          this.file = event.node.data;
          this.previousFileId = currentFileId;
          this.fileSelectionCounter++;

          // If same file was selected again, close any open modals first
          if (isFileSameAsLast) {
            if (this.articleViewerRef) {
              this.articleViewerRef.hideModal?.();
            }
            if (this.checklistViewerRef) {
              this.checklistViewerRef.hideModal?.();
            }
            if (this.larViewerRef) {
              this.larViewerRef.hideModal?.();
            }
          }

          // Trigger change detection first to ensure component is rendered
          this.cdr.detectChanges();

          // Call showModal() for viewers that don't auto-trigger with [isDialog]
          // Using a longer timeout to ensure component initialization
          setTimeout(() => {
            if (
              this.file.type === 'file' &&
              this.file.documentType === 'article' &&
              this.articleViewerRef
            ) {
              this.articleViewerRef.showModal();
            }
            if (
              this.file.type === 'file' &&
              this.file.documentType === 'checklist' &&
              this.file.featureId != 36 &&
              this.checklistViewerRef
            ) {
              this.checklistViewerRef.showModal();
            }
            if (
              (this.file.documentType === 'law' ||
                this.file.documentType === 'laws' ||
                this.file.documentType === 'regulation' ||
                this.file.documentType === 'videos') &&
              this.larViewerRef
            ) {
              this.larViewerRef.showModal();
            }
          }, 150);
        }
        // Single-click (openViewer=false): do nothing, don't set this.file, don't open viewers
      } else if (event.node.data.type !== 'file') {
        // Clear file viewer when selecting folders or other non-file nodes
        this.file = null;
        this.cdr.detectChanges();
      }
    }

    this.ecplNodeEvent.emit(event);
  }

  // manual events
  saveUpdateEvents(event: any, eventName: any) {
    event.eventName = eventName;
    switch (eventName) {
      case 'AddNewRootFolder':
        // add new node in selected folder with input fields and expand and focus
        this.getTreeModel().setActiveNode(event.item, true);
        this.bsModalTitle = this.translate.instant('NEW_ROOT_FOLDER');
        this.currentEventData = event;
        this.bsModalRef = this.bsModalService.show(
          this.newFolderModal,
          this.bsConfig
        );
        break;
      case 'AddNewSiblingFolder':
        // add new node at same level as selected folder
        this.getTreeModel().setActiveNode(event.item, true);
        this.bsModalTitle = this.translate.instant('NEW_FOLDER');
        this.currentEventData = event;
        this.bsModalRef = this.bsModalService.show(
          this.newFolderModal,
          this.bsConfig
        );
        break;

      case 'AddNewFolder':
        // add new node in selected folder with input fields and expand and focus
        this.getTreeModel().setExpandedNode(event.item, true);
        this.getTreeModel().setActiveNode(event.item, true);
        this.bsModalTitle = this.translate.instant('NEW_SUB_FOLDER');
        this.currentEventData = event;
        this.bsModalRef = this.bsModalService.show(
          this.newFolderModal,
          this.bsConfig
        );
        break;

      case 'AddFiles':
        // Open windows file explorer for upload from file-window explorer component
        this.getTreeModel().setActiveNode(event.item, true);
        this.ecplNodeEvent.emit(event);
        break;

      case 'EditFile':
        // if office file open in onlyoffice viewer
        this.getTreeModel().setActiveNode(event.item, true);
        this.file = event.item.data;
        this.cdr.detectChanges();
        this.triggerFalseClick();

        break;

      case 'RenameFile':
        this.newFolderNode.filename = event.item.data.filename;
        this.bsModalTitle = 'Rename : ' + event.item.data.filename;
        this.currentEventData = event;
        this.bsModalRef = this.bsModalService.show(
          this.newFolderModal,
          this.bsConfig
        );

        break;

      case 'DeleteFile':
        // Remove node from tree and emit acction
        this.getTreeModel().setActiveNode(event.item, true);
        if (
          !confirm('Are you sure want to delete ' + event.item.data.filename)
        ) {
          return false;
        }
        this.ecplNodeEvent.emit(event);
        break;

      case 'AddArticle':
        BaseServices.setArticleId(0);
        this.file = new ArticleModel();
        this.file.id = 0;
        this.file.nodeId = 0;
        this.file.filename = '';
        this.file.originalFileName = '';
        this.file.path = '';
        this.file.mimetype = '';
        this.file.size = 0;
        this.file.isFolder = false;
        this.file.type = 'file';
        this.file.isDefault = false;
        this.file.documentType = 'article';
        this.file.status = 1;
        this.file.createdBy = this.UserId;
        this.file.modifiedBy = this.UserId;
        this.file.parentFolderId = event.item.parentFolderId;
        this.file.documentTypeId = event.item.documentTypeId;
        if (this.businessId === 0 && this.portalId === 0) {
          this.file.content = {
            article: {
              id: 0,
              articleName: '',
              documentNumber: null,
              chapter: '',
              version: 1,
              roleStatus: {
                admin: [
                  { name: 'Own Text', status: 'Active', disable: 'false' },
                  { name: 'Standard Text', status: 'Active', disable: 'false' },
                  { name: 'Legislation', status: 'Active', disable: 'false' }
                ],
                portal: [
                  { name: 'Own Text', status: 'Active', disable: 'false' },
                  { name: 'Portal Text', status: 'Active', disable: 'false' },
                  { name: 'Standard Text', status: 'Active', disable: 'false' },
                  { name: 'Legislation', status: 'Active', disable: 'false' }
                ],
                editor: [
                  { name: 'Own Text', status: 'Active', disable: 'false' },
                  { name: 'Portal Text', status: 'Active', disable: 'false' },
                  { name: 'Standard Text', status: 'Active', disable: 'false' },
                  { name: 'Legislation', status: 'Active', disable: 'false' }
                ]
              }
            },
            subArticles: [
              {
                name: 'Own Text',
                text: '',
                version: 1,
                status: 'Active'
              },
              {
                name: 'Portal Text',
                text: '',
                version: 1,
                status: 'Active'
              },
              {
                name: 'Standard Text',
                text: '',
                version: 1,
                status: 'Active'
              },
              {
                name: 'Legislation',
                text: '',
                version: 1,
                status: 'Active'
              }
            ],
            revisionComments: null
          };
        } else if (this.portalId !== 0 && this.businessId === 0) {
          this.file.content = {
            article: {
              id: 0,
              articleName: '',
              documentNumber: null,
              chapter: '',
              version: 1,
              roleStatus: {
                admin: [],
                portal: [
                  { name: 'Own Text', status: 'Active', disable: 'false' },
                  { name: 'Portal Text', status: 'Active', disable: 'false' }
                ],
                editor: [
                  { name: 'Own Text', status: 'Active', disable: 'false' },
                  { name: 'Portal Text', status: 'Active', disable: 'false' }
                ]
              }
            },
            subArticles: [
              {
                name: 'Own Text',
                text: '',
                version: 1,
                status: 'Active'
              },
              {
                name: 'Portal Text',
                text: '',
                version: 1,
                status: 'Active'
              }
            ],
            revisionComments: null
          };
        } else if (this.businessId !== 0 && this.projectId !== undefined) {
          this.file.content = {
            article: {
              id: 0,
              articleName: '',
              documentNumber: null,
              chapter: '',
              version: 1
            },
            subArticles: [
              {
                name: 'Project Text',
                text: '',
                version: 1,
                status: 'Active'
              },
              {
                name: 'Own Text',
                text: '',
                version: 1,
                status: 'Active'
              },
              {
                name: 'Portal Text',
                text: '',
                version: 1,
                status: 'Active'
              }
            ],
            revisionComments: null
          };
        } else if (this.portalId === 0 && this.businessId !== 0) {
          this.file.content = {
            article: {
              id: 0,
              articleName: '',
              documentNumber: null,
              chapter: '',
              version: 1,
              roleStatus: {
                admin: [],
                portal: [],
                editor: [
                  { name: 'Own Text', status: 'Active', disable: 'false' }
                ]
              }
            },
            subArticles: [
              {
                name: 'Own Text',
                text: '',
                version: 1,
                status: 'Active'
              }
            ],
            revisionComments: null
          };
        } else {
        }

        this.currentEventData = event;

        this.cdr.detectChanges();
        this.triggerFalseClick();
        break;

      case 'EditArticle':
        // Open article viewer with data
        this.getTreeModel().setActiveNode(event.item, true);
        this.file = event.item.data;
        this.currentEventData = event;
        this.cdr.detectChanges();
        this.triggerFalseClick();
        break;

      case 'RenameArticle':
        this.newFolderNode.filename = event.item.data.filename;
        this.bsModalTitle = 'Rename : ' + event.item.data.filename;
        this.currentEventData = event;
        this.bsModalRef = this.bsModalService.show(
          this.newFolderModal,
          this.bsConfig
        );

        break;
      case 'DeleteArticle':
        // Remove node from tree and emit action
        this.getTreeModel().setActiveNode(event.item, true);
        if (
          !confirm('Are you sure want to delete ' + event.item.data.filename)
        ) {
          return false;
        }
        this.ecplNodeEvent.emit(event);
        break;
      case 'AddChecklist':
        // open empty checklist viewer
        this.currentEventData = event;
        this.file = null;
        this.file = new ChecklistModel();
        this.file.filename = '';
        this.file.originalFileName = '';
        this.file.path = '';
        this.file.mimetype = 'checklist';
        this.file.size = 0;
        this.file.isFolder = false;
        this.file.type = 'file';
        this.file.isDefault = false;
        this.file.documentType = 'checklist';
        this.file.status = 1;
        this.file.createdBy = BaseServices.UserId;
        this.file.modifiedBy = BaseServices.UserId;
        this.file.createdOn = new Date();
        this.file.parentFolderId = 0;
        this.file.documentTypeId = 0;
        this.file.content = {
          checkList: {
            id: 0,
            title: '',
            scoreIndex: false,
            isEditable: true,
            status: 1,
            createdOn: new Date(),
            sections: [
              {
                id: 0,
                position: 1,
                title: '',
                status: 1,
                items: [
                  {
                    id: 0,
                    position: 1,
                    title: '',
                    status: 1
                  }
                ]
              }
            ]
          }
        };
        this.cdr.detectChanges();
        this.openChecklistViewer();
        break;

      case 'EditChecklist':
        // Open checklist viewer with data
        this.currentEventData = event;
        this.getTreeModel().setActiveNode(event.item, true);
        this.file = null;
        this.file = event.item.data;
        this.cdr.detectChanges();
        this.openChecklistViewer();

        break;

      case 'RenameChecklist':
        this.newFolderNode.filename = event.item.data.filename;
        this.bsModalTitle = 'Rename : ' + event.item.data.filename;
        this.currentEventData = event;
        this.bsModalRef = this.bsModalService.show(
          this.newFolderModal,
          this.bsConfig
        );

        break;
      case 'DeleteChecklist':
        // Remove node from tree and emit action
        this.getTreeModel().setActiveNode(event.item, true);
        if (
          !confirm('Are you sure want to delete ' + event.item.data.filename)
        ) {
          let result: any;
          return result;
        }
        this.ecplNodeEvent.emit(event);
        break;
      case 'EditLaws':
        // Open law viewer with data
        this.getTreeModel().setActiveNode(event.item, true);
        this.file = event.item.data;
        this.cdr.detectChanges();
        this.triggerFalseClick();

        break;

      case 'EditRegulations':
        // Open regulation viewer with data
        this.getTreeModel().setActiveNode(event.item, true);
        this.file = event.item.data;
        this.cdr.detectChanges();
        this.triggerFalseClick();

        break;
      case 'RenameFolder':
        // edit node(filename) name input field and emit action
        this.getTreeModel().setActiveNode(event.item, true);
        this.getTreeModel().setExpandedNode(event.item, true);
        this.newFolderNode.filename = event.item.data.filename;
        this.bsModalTitle = 'Rename : ' + event.item.data.filename;
        this.currentEventData = event;
        this.bsModalRef = this.bsModalService.show(
          this.newFolderModal,
          this.bsConfig
        );

        break;
      case 'DeleteFolder':
        // Remove node from tree and emit action
        this.getTreeModel().setActiveNode(event.item, true);
        let childCount =
          event.item.data.childCount > 0
            ? ' (' + event.item.data.childCount + ')?'
            : '?';
        let hasNodeMsg =
          event.item.data.childCount > 0 ? ' It has sub nodes.' : '';
        if (
          !confirm(
            'Are you sure want to delete ' +
              event.item.data.filename +
              childCount +
              hasNodeMsg
          )
        ) {
          return false;
        }
        this.getTreeModel().setActiveNode(event.item.parent, true);
        this.ecplNodeEvent.emit(event);
        break;
      case 'DragDropFolder':
        // emit event with from-folder and to-folder
        break;
      case 'DragDropArticle':
        // emit event with from-folder and to-folder
        break;
      case 'DragDropChecklist':
        // emit event with from-folder and to-folder
        break;
      case 'DragDropDocument':
        // emit event with from-folder and to-folder
        break;

      default:
        this.ecplNodeEvent.emit(event);
        break;
    }
  }

  setNodeStatus(node: any, event: any) {
    // Prevent rapid successive calls that cause crashes
    if (this.isDestroyed) return;

    if (node.data.status === 1) {
      if (node.data.nodes != null) {
        if (node.data.nodes.length > 0) {
          for (var i = 0; i < node.data.nodes.length; i++) {
            node.data.nodes[i].status = 2;
          }
        }
      }
      node.data.status = 2;
    } else {
      if (node.data.nodes != null) {
        if (node.data.nodes.length > 0) {
          for (var i = 0; i < node.data.nodes.length; i++) {
            node.data.nodes[i].status = 1;
          }
        }
      }
      node.data.status = 1;
    }

    // Debounce the change detection and event emission to prevent crashes from rapid clicks
    if (this.statusChangeDebounceTimer) {
      clearTimeout(this.statusChangeDebounceTimer);
    }

    this.statusChangeDebounceTimer = setTimeout(() => {
      if (this.isDestroyed) return;
      this.safeDetectChanges();
      event.eventName = 'CheckBoxStatus';
      event.node = node;
      this.ecplNodeEvent.emit(event);
    }, 100);
  }

  /**
   * Safe wrapper for detectChanges that checks if component is still active
   */
  private safeDetectChanges(): void {
    if (this.isDestroyed) return;
    try {
      this.cdr.detectChanges();
    } catch (e) {
      // Ignore errors from disconnected change detector
      console.warn('detectChanges skipped - component may be destroyed');
    }
  }

  //#endregion

  //#region Component life cycle hooks
  ngOnChanges(changes: SimpleChanges) {
    if (changes['ecplTreeData'] && changes['ecplTreeData'].currentValue) {
      // Skip rebuild if flag is set (during merge operations)
      if (this.skipRebuildOnChange) {
        this.skipRebuildOnChange = false;
        return;
      }

      this.newFolderNode = {
        filename: ''
      };

      // Keep the user's expanded folders when the data is reloaded (e.g. after a move)
      const expandedState = this.captureExpandedState(this.primeNodes);
      this.nodes = this.ecplTreeData;
      this.buildPrimeNodes();
      this.restoreExpandedState(this.primeNodes, expandedState);
      this.expandNewRootFolders(expandedState);
      this.cdr.detectChanges();
    }
    if (
      changes['ecplTreeCheckbox'] &&
      changes['ecplTreeCheckbox'].currentValue !==
        changes['ecplTreeCheckbox'].previousValue
    ) {
      // When toggling edit mode, capture expansion state, rebuild (with filtering), then restore
      const expandedState = this.captureExpandedState(this.primeNodes);
      this.setTreeOptionsAndData();
      this.buildPrimeNodes(); // This will filter nodes based on new ecplTreeCheckbox value
      this.restoreExpandedState(this.primeNodes, expandedState);
      this.getTreeModel().update();
      this.cdr.detectChanges();
    }
  }

  /**
   * Filter nodes based on status, edit mode, and admin level
   * At business level: always hide isPermission=false (even in edit mode)
   * In view mode: also hide status=2
   */
  private filterNodesByStatus(nodes: EcplTreeData[]): EcplTreeData[] {
    if (!nodes) return [];
    return nodes
      .filter(node => {
        // At business level, always hide nodes where admin set isPermission=false
        if (!this.isAdminManual && (node as any).isPermission === false) {
          return false;
        }
        // In edit mode at admin level, show all remaining nodes
        if (this.ecplTreeCheckbox && this.isAdminManual) return true;
        // In edit mode at business level, show nodes that passed the isPermission check
        if (this.ecplTreeCheckbox) return true;
        // In view mode, also hide nodes with status=2
        return node.status !== 2;
      })
      .map(node => ({
        ...node,
        nodes: node.nodes ? this.filterNodesByStatus(node.nodes) : []
      }));
  }

  /**
   * Capture which nodes are expanded before refresh
   */
  private captureExpandedState(
    nodes: any[],
    state: Map<string, boolean> = new Map()
  ): Map<string, boolean> {
    if (!nodes) return state;
    nodes.forEach(node => {
      if (node.data) {
        state.set(treeNodeKey(node.data), node.expanded || false);
      }
      if (node.children && node.children.length > 0) {
        this.captureExpandedState(node.children, state);
      }
    });
    return state;
  }

  /**
   * Restore expansion state after tree refresh
   */
  private restoreExpandedState(
    nodes: any[],
    state: Map<string, boolean>
  ): void {
    if (!nodes) return;
    nodes.forEach(node => {
      const key = node.data ? treeNodeKey(node.data) : null;
      if (key && state.has(key)) {
        node.expanded = state.get(key);
      }
      if (node.children && node.children.length > 0) {
        this.restoreExpandedState(node.children, state);
      }
    });
  }

  /**
   * With `expandRootFolders`, expand first-level folders the user has not seen yet — all of
   * them on first load. Folders already shown keep whatever the user left them at.
   */
  private expandNewRootFolders(previousState: Map<string, boolean>): void {
    if (!this.expandRootFolders) return;
    for (const root of this.primeNodes) {
      if (
        root.data &&
        !previousState.has(treeNodeKey(root.data)) &&
        root.children &&
        root.children.length > 0
      ) {
        root.expanded = true;
      }
    }
  }

  /**
   * Refresh tree and preserve expansion state
   */
  refreshAndPreserveState(newData: EcplTreeData[]): void {
    const expandedState = this.captureExpandedState(this.primeNodes);
    this.ecplTreeData = newData;
    const filteredData = this.filterNodesByStatus(newData);
    this.nodes = filteredData;
    this.buildPrimeNodes();
    this.restoreExpandedState(this.primeNodes, expandedState);
    this.cdr.detectChanges();
  }

  ngOnInit() {
    if (this.treeId) {
      const roots = this.getTreeModel().nodes || [];
      const tree = roots[0];
      if (tree && tree.data) {
        if (tree.data.originalFileName === 'Archive') {
          if (typeof tree.expand === 'function') tree.expand();
        }
      }
    }
  }

  ngAfterViewInit() {
    this.setTreeOptionsAndData();
    // ensure treeModel shim is available so older code referencing treeComponent.treeModel continues to work
    try {
      // attach the shim onto the actual PrimeNG treeComponent so external
      // callers that still reference this.treeComponent.treeModel will find it.
      if (!this.treeComponent) this.treeComponent = {} as any;
      // prefer existing treeModel if present, otherwise assign shim
      this.treeComponent.treeModel =
        this.treeComponent.treeModel ||
        this.treeModelShim ||
        this.createTreeModelShim();
    } catch (e) {}
  }

  // Convert incoming ecplTreeData into PrimeNG TreeNodes (value for p-tree)
  private buildPrimeNodes() {
    try {
      let dataToUse = this.ecplTreeData;

      // Store current selected node ID to restore selection after rebuild
      const selectedId =
        this.selectedNode && this.selectedNode.data
          ? this.selectedNode.data.id || this.selectedNode.data.nodeId
          : null;

      // At business level: always filter out nodes with isPermission=false (even in edit mode)
      // These are items hidden by admin that business level cannot control
      if (!this.isAdminManual) {
        dataToUse = this.filterAdminHiddenNodes(dataToUse);
      }

      // In view mode (not edit mode): also filter out status=2 nodes
      if (!this.ecplTreeCheckbox) {
        dataToUse = this.filterStatusTwoNodes(dataToUse);
      }

      this.primeNodes = (dataToUse || []).map(d => this.convertNode(d, 0));
      this.filteredPrimeNodes = this.primeNodes;

      // Restore selected node by ID if we have one
      if (selectedId) {
        const found = this.findNodeById(selectedId);
        if (found) {
          this.selectedNode = found;
          this._activeNode = found;
        }
      }
    } catch (e) {
      this.primeNodes = [];
      this.filteredPrimeNodes = [];
    }
  }

  /**
   * Filter out nodes hidden by admin (isPermission=false) - used at business level
   * Business users cannot see or control these items
   */
  private filterAdminHiddenNodes(nodes: any[]): any[] {
    if (!nodes) return [];
    return nodes
      .filter(node => node.isPermission !== false)
      .map(node => ({
        ...node,
        nodes: node.nodes ? this.filterAdminHiddenNodes(node.nodes) : []
      }));
  }

  /**
   * Filter out nodes with status=2 (hidden locally) - used in view mode
   */
  private filterStatusTwoNodes(nodes: any[]): any[] {
    if (!nodes) return [];
    return nodes
      .filter(node => node.status !== 2)
      .map(node => ({
        ...node,
        nodes: node.nodes ? this.filterStatusTwoNodes(node.nodes) : []
      }));
  }

  private convertNode(data: any, depth: number): any {
    const node: any = {
      data: data,
      label: data.filename,
      expanded: !!data.expanded,
      selectable: true,
      children: Array.isArray(data.nodes)
        ? data.nodes.map((c: any) => this.convertNode(c, depth + 1))
        : []
    };
    // mark whether node has children (compat with circlon TreeNode.hasChildren)
    node.hasChildren = Array.isArray(node.children) && node.children.length > 0;
    // ensure child nodes have a parent reference (some callers use node.parent)
    if (Array.isArray(node.children)) {
      for (const child of node.children) {
        child.parent = node;
      }
    }
    // keep compatibility with older templates that expect node.data._depth or node.data.nodes
    node.data._depth = depth;
    // restore nodes reference for pipes
    node.data.nodes = data.nodes || [];
    // PrimeNG uses 'children' but some code checks nodes; keep both
    (node as any).nodes = node.children;
    // also keep hasChildren on the data layer for code that inspects data.hasChildren
    node.data.hasChildren = node.hasChildren;
    // provide small compatibility helpers expected by circlon TreeNode
    node.setIsSelected = (selected: boolean) => {
      try {
        node.selected = !!selected;
        if (node.data) node.data.selected = !!selected;
        this.cdr.detectChanges();
      } catch (e) {}
    };
    node.expand = () => {
      node.expanded = true;
      this.cdr.detectChanges();
    };
    node.collapse = () => {
      node.expanded = false;
      this.cdr.detectChanges();
    };
    return node;
  }

  private findNodeById(id: any, nodes?: any[]): any {
    const list = nodes || this.primeNodes;
    for (const n of list) {
      const d = n.data || n;
      if (String(d.id) === String(id) || String(d.nodeId) === String(id))
        return n;
      const children = n.children || n.nodes || (d && d.nodes);
      if (Array.isArray(children) && children.length) {
        const found = this.findNodeById(id, children);
        if (found) return found;
      }
    }
    return null;
  }

  private createTreeModelShim(): any {
    const self = this;
    return {
      getActiveNode() {
        return self._activeNode;
      },
      setActiveNode(item: any, focus?: boolean) {
        // accept either prime node or data object
        if (!item) {
          self._activeNode = null;
          return;
        }
        let node = item;
        if (item && item.data) node = item;
        else if (item && item.id) node = self.findNodeById(item.id) || item;
        // clear previous active flags
        try {
          if (self._activeNode && self._activeNode.data) {
            self._activeNode.data.isActive = false;
            self._activeNode.data.isFocused = false;
          }
        } catch (e) {}
        self._activeNode = node;
        self.selectedNode = node;
        try {
          self.selection = node;
        } catch (e) {}
        // set active/focused flags so templates depending on node.data.status/class pick up
        try {
          if (node && node.data) {
            node.data.isActive = true;
            node.data.isFocused = true;
          }
        } catch (e) {}
        self.cdr.detectChanges();
      },
      setExpandedNode(item: any, expanded: boolean) {
        const node =
          item && item.data
            ? item
            : this.getNodeById(
                item && item.data
                  ? item.data.id
                  : item && item.id
                    ? item.id
                    : null
              );
        if (node) node.expanded = expanded;
        self.cdr.detectChanges();
      },
      update() {
        self.cdr.detectChanges();
      },
      get nodes() {
        return self.primeNodes;
      },
      getNodeById(id: any) {
        return self.findNodeById(id);
      }
    };
  }

  // UI handlers adapting PrimeNG tree events to the legacy event shapes
  toggleNode(node: any, ev?: Event) {
    ev && ev.stopPropagation();
    node.expanded = !node.expanded;
  }

  onNodeClick(node: any, ev?: Event) {
    ev && ev.stopPropagation();
    // Single-click: select the node, emit activate for folders, but don't open file viewers
    this.selectedNode = node;
    this._activeNode = node;
    try {
      this.getTreeModel().setActiveNode(node, true);
    } catch (e) {}

    const isFolder =
      (node && node.children && node.children.length > 0) ||
      node?.data?.type === 'folder';

    if (isFolder) {
      // Emit activate with openViewer flag
      const event = { eventName: 'activate', node: node, openViewer: false };
      this.sendTreeEvents(event);
    }

    // Also emit focus event for compatibility with components like KubaCompleteChecklist
    const focusEvent = { eventName: 'focus', node };
    this.sendTreeEvents(focusEvent);

    this.scheduleLabelToggle(node);

    // Trigger change detection to show arrow for selected node
    this.cdr.detectChanges();
  }

  /**
   * In "add from manuals", clicking anywhere on a file row toggles its checkbox. The toggle
   * is delayed so a double click (which opens the file) can cancel it.
   */
  scheduleLabelToggle(node: any) {
    this.cancelLabelToggle();
    const isFile = node?.data?.type === 'file';
    if (
      !this.ecplTreeCheckbox ||
      !this.addFromManuals ||
      !isFile ||
      node.data.isPermission === false
    ) {
      return;
    }
    this.labelToggleTimer = setTimeout(() => {
      this.labelToggleTimer = null;
      this.setNodeStatus(node, {});
    }, 250);
  }

  cancelLabelToggle() {
    if (this.labelToggleTimer) {
      clearTimeout(this.labelToggleTimer);
      this.labelToggleTimer = null;
    }
  }

  onNodeDblClick(node: any, ev?: Event) {
    ev && ev.stopPropagation();
    this.cancelLabelToggle();

    this.selectedNode = node;
    this._activeNode = node;

    // On double click:
    // - For folders: toggle expansion
    // - For files: open viewer
    try {
      if (node && node.children && node.children.length > 0) {
        // Folder: toggle expansion
        node.expanded = !node.expanded;
      } else if (node && node.data && node.data.type === 'file') {
        // File: emit activate with openViewer=true to open viewer
        const event = { eventName: 'activate', node, openViewer: true };
        this.sendTreeEvents(event);
      }

      // Also emit focus event on double click
      const focusEvent = { eventName: 'focus', node };
      this.sendTreeEvents(focusEvent);

      try {
        this.getTreeModel().setActiveNode(node, true);
      } catch (e) {}
    } catch (e) {}
  }

  onNodeContextMenu(node: any, ev?: Event) {
    ev && ev.preventDefault();
    const event = { eventName: 'contextMenu', node, originalEvent: ev };
    this.sendTreeEvents(event);
  }

  onNodeExpand(ev: any) {
    const event = { eventName: 'expand', node: ev.node };
    this.sendTreeEvents(event);
  }

  onNodeCollapse(ev: any) {
    const event = { eventName: 'collapse', node: ev.node };
    this.sendTreeEvents(event);
  }

  //#region Drag and drop
  // Native HTML5 drag and drop on .node-wrapper. Every handler stops propagation so PrimeNG's
  // own row handlers (DnD disabled on p-tree) cannot cancel the drag or reset dropEffect.

  /**
   * Every row can be picked up while dragging is enabled, so a node that may not be moved
   * gets an explanation in onNodeDragStart instead of a drag that silently never starts.
   */
  isNodeDraggable(node: any): boolean {
    return !!this.allowDrag && !!node && !!node.data;
  }

  onNodeDragStart(node: any, event: DragEvent) {
    event.stopPropagation();
    if (!this.isNodeDraggable(node)) {
      event.preventDefault();
      return;
    }
    // A tree that accepts drops moves nodes in place. A drag-only tree is a copy source
    // (e.g. manuals → documents), where any node may be copied.
    const refusal = this.allowDrop ? this.getMoveRejection(node.data) : null;
    if (refusal) {
      event.preventDefault();
      this.showAlert(this.translate.instant(refusal));
      return;
    }
    this.dragDropService.setLastNode(
      { ...node.data },
      this.treeId,
      this.treeType
    );
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'copyMove';
      // Firefox does not start a drag without data
      event.dataTransfer.setData('text/plain', String(node.data.nodeId ?? ''));
    }
  }

  onNodeDragEnd(event: DragEvent) {
    event.stopPropagation();
    this.dropTargetNode = null;
    setTimeout(() => this.dragDropService.clearLastNode(), 50);
  }

  onNodeDragOver(node: any, ev: DragEvent) {
    ev.stopPropagation();
    const draggedNode = this.dragDropService.getLastNode();
    if (!this.canDropOn(draggedNode, node)) {
      this.dropTargetNode = null;
      if (ev.dataTransfer) ev.dataTransfer.dropEffect = 'none';
      return;
    }
    // Rule violations still accept the drop, so onNodeDrop can explain why it was refused;
    // only valid targets are highlighted.
    ev.preventDefault();
    if (ev.dataTransfer) {
      ev.dataTransfer.dropEffect = this.isCrossTreeDrag() ? 'copy' : 'move';
    }
    const isValidTarget =
      this.getDropRejection(draggedNode, node, this.isCrossTreeDrag()) === null;
    this.dropTargetNode = isValidTarget ? node : null;
  }

  onNodeDragLeave(node: any, ev: DragEvent) {
    ev.stopPropagation();
    // dragleave also fires when moving between the row's own children
    const related = ev.relatedTarget as Node | null;
    if (related && (ev.currentTarget as HTMLElement).contains(related)) {
      return;
    }
    if (this.dropTargetNode === node) {
      this.dropTargetNode = null;
    }
  }

  onNodeDrop(node: any, ev: DragEvent) {
    ev.preventDefault();
    ev.stopPropagation();
    this.dropTargetNode = null;

    const draggedNode = this.dragDropService.getLastNode();
    if (!this.canDropOn(draggedNode, node)) {
      return;
    }

    const isCrossTree = this.isCrossTreeDrag();
    const rejection = this.getDropRejection(draggedNode, node, isCrossTree);
    if (rejection) {
      this.showAlert(this.translate.instant(rejection));
      return;
    }

    // Dropping into another tree copies; within a tree it moves
    const eventName = this.isCopyMode || isCrossTree ? 'copyNode' : 'moveNode';
    this.ecplNodeEvent.emit({
      eventName: eventName,
      node: draggedNode,
      from: { data: draggedNode },
      to: { parent: node },
      originalEvent: ev
    });
  }

  private isCrossTreeDrag(): boolean {
    return this.dragDropService.getSourceTreeId() !== this.treeId;
  }

  /**
   * Whether `target` can receive a drop at all. Drops that would change nothing — onto the
   * dragged node itself, into its own subtree, or into the folder it is already in — are
   * ignored without a message.
   */
  private canDropOn(draggedNode: any, target: any): boolean {
    if (!this.allowDrop || !draggedNode || !target || !target.data) {
      return false;
    }
    if (target.data.type === 'file') {
      return false;
    }
    if (this.isCrossTreeDrag()) {
      return true;
    }
    const draggedKey = treeNodeKey(draggedNode);
    for (let n = target; n; n = n.parent) {
      if (n.data && treeNodeKey(n.data) === draggedKey) {
        return false;
      }
    }
    const isCurrentParent = (target.children || []).some(
      (child: any) => child.data && treeNodeKey(child.data) === draggedKey
    );
    return !isCurrentParent;
  }

  /**
   * Returns the translation key explaining why a node may not be moved within its tree, or
   * null when it may. Default folders are fixed. Content owned by a higher level
   * (`isEditable === false`) is one shared row read by every business under it, so moving it
   * from one business would move it for all of them. A business's own copies stay movable.
   */
  private getMoveRejection(data: any): string | null {
    if (data.isDefault === true && data.type === 'folder') {
      return 'DEFAULT_FOLDER_RESTRICTION';
    }
    if (data.isEditable === false) {
      return data.portalId
        ? 'NOT_ALLOWED_DRAG_DROP_PORTAL_FILE'
        : 'NOT_ALLOWED_DRAG_DROP_ADMIN_FILE';
    }
    return null;
  }

  /**
   * Returns the translation key explaining why `draggedNode` may not be dropped on `target`,
   * or null when the drop is allowed.
   */
  private getDropRejection(
    draggedNode: any,
    target: any,
    isCrossTree: boolean
  ): string | null {
    const toParentData = target.data;

    if (!isCrossTree) {
      const moveRejection = this.getMoveRejection(draggedNode);
      if (moveRejection) {
        return moveRejection;
      }
    }

    if (
      toParentData.documentType === 'article' &&
      draggedNode.mimetype !== 'article' &&
      draggedNode.type !== 'folder'
    ) {
      return 'NOT_ALLOWED_DRAG_DROP_OTHER_THAN_ARTICLE';
    }

    if (
      toParentData.documentType === 'checklist' &&
      draggedNode.mimetype !== 'checklist' &&
      draggedNode.type !== 'folder'
    ) {
      return 'NOT_ALLOWED_DRAG_DROP_OTHER_THAN_CHECKLIST';
    }

    // Articles and checklists do not belong in document folders
    if (
      ['article', 'checklist'].includes(draggedNode.mimetype) &&
      toParentData.documentType === 'document'
    ) {
      return 'NOT_ALLOWED_DRAG_DROP_NON_DOCUMENT';
    }

    // Folders and content stay within folders of their own type
    if (toParentData.documentType !== draggedNode.documentType) {
      return 'NOT_ALLOWED_DRAG_DROP_DIFFERENT_FOLDER_TYPE';
    }

    return null;
  }

  //#endregion

  onNodeSelect(ev: any) {
    if (ev.node) {
      // Also emit focus event for PrimeNG selection events
      const focusEvent = { eventName: 'focus', node: ev.node };
      this.sendTreeEvents(focusEvent);
    }
  }

  onNodeUnselect(ev: any) {
    const event = { eventName: 'deactivate', node: ev.node };
    this.sendTreeEvents(event);
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    this.dragAutoScroll.detach();
    this.cancelLabelToggle();
    if (this.statusChangeDebounceTimer) {
      clearTimeout(this.statusChangeDebounceTimer);
    }
  }

  //#endregion

  //#region Private funs

  setTreeOptionsAndData() {
    // angular2-tree options
    this.options = {
      displayField: 'filename',
      isExpandedField: 'expanded',
      idField: 'id',
      hasChildrenField: 'isFolder',
      childrenField: 'nodes',
      nodeClass: (node: TreeNode) => {
        return 'ecpl-tree-icon-' + node.data.mimetype;
      },
      allowDrag: (node: any | null) => {
        if (!node.data.isDefault && this.ecplTreeCheckbox) {
          return true;
        }
        return false;
      },
      allowDrop: (element, { parent, index }) => {
        return true;
      },
      actionMapping: {
        mouse: {
          dblClick: (tree: any, node: any, $event: any) => {
            if (node.hasChildren) {
              TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
            } else {
              TREE_ACTIONS.TOGGLE_ACTIVE(tree, node, $event);
              this.triggerFalseClick();
            }
          },
          checkboxClick: (tree: any, node: any, $event: any) => {
            TREE_ACTIONS.EXPAND(tree, node, $event);
            TREE_ACTIONS.TOGGLE_SELECTED(tree, node, $event);
          },
          contextmenu: (tree: any, node: any, $event: any) => {
            if (node.hasChildren) {
              TREE_ACTIONS.EXPAND(tree, node, $event);
            } else {
              TREE_ACTIONS.TOGGLE_ACTIVE(tree, node, $event);
            }
          },
          drop: (
            tree: TreeModel,
            node: TreeNode,
            $event: any,
            { from, to }
          ) => {
            // recover 'from' robustly
            from = this.extractFrom(tree, $event, from);

            if (!from || !from.data) {
              return;
            }

            // support both TreeNode shapes and plain data objects
            const fromData = from.data ? from.data : from;
            const toParentData = to && to.parent ? to.parent.data : null;

            // your existing permission / type checks
            if (
              this.portalId !== 0 &&
              fromData.portalId === 0 &&
              fromData.businessId === 0
            ) {
              this.showAlert(
                this.translate.instant('NOT_ALLOWED_DRAG_DROP_ADMIN_FILE') ||
                  'Not allowed to drag and drop admin file'
              );
              return;
            }

            if (
              (this.businessId !== 0 &&
                fromData.portalId === 0 &&
                fromData.businessId === 0) ||
              (this.businessId !== 0 &&
                fromData.portalId !== 0 &&
                fromData.businessId === 0)
            ) {
              if (fromData.portalId === 0 && fromData.businessId === 0) {
                this.showAlert(
                  this.translate.instant('NOT_ALLOWED_DRAG_DROP_ADMIN_FILE') ||
                    'Not allowed to drag and drop admin file'
                );
              } else if (fromData.portalId !== 0 && fromData.businessId === 0) {
                this.showAlert(
                  this.translate.instant('NOT_ALLOWED_DRAG_DROP_PORTAL_FILE') ||
                    'Not allowed to drag and drop portal file'
                );
              }
              return;
            }

            if (
              toParentData &&
              toParentData.documentType == 'article' &&
              fromData.mimetype != 'article' &&
              fromData.type != 'folder'
            ) {
              this.showAlert(
                this.translate.instant(
                  'NOT_ALLOWED_DRAG_DROP_OTHER_THAN_ARTICLE'
                ) || 'Not allowed to drag and drop other than article file'
              );
              return;
            }

            if (
              toParentData &&
              toParentData.documentType == 'checklist' &&
              fromData.mimetype != 'checklist' &&
              fromData.type != 'folder'
            ) {
              this.showAlert(
                this.translate.instant(
                  'NOT_ALLOWED_DRAG_DROP_OTHER_THAN_CHECKLIST'
                ) || 'Not allowed to drag and drop other than checklist'
              );
              return;
            }

            // perform the move/copy (let the tree handle clone/move behavior)
            TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });

            // clear the shared last-dragged node after a short delay
            setTimeout(() => this.dragDropService.clearLastNode(), 50);
          }
        },
        keys: {
          [KEYS.ENTER]: (tree: any, node: any, $event: any) => {
            node.expand();
          }
        }
      },
      nodeHeight: 24,
      useCheckbox: this.ecplTreeCheckbox,
      useVirtualScroll: false,
      animateExpand: true,
      animateSpeed: 30,
      animateAcceleration: 1.2
    };

    this.staticOptions = {
      displayField: 'filename',
      isExpandedField: 'expanded',
      idField: 'id',
      hasChildrenField: 'isFolder',
      childrenField: 'nodes',
      nodeClass: (node: TreeNode) => {
        return 'ecpl-tree-icon-' + node.data.mimetype;
      },
      allowDrag: this.allowDrag,
      allowDrop: this.allowDrop,
      getNodeClone: (node: any | null) => ({
        ...node.data,
        id: UUID.UUID(),
        filename: `${node.data.filename}`
      }),
      actionMapping: {
        mouse: {
          dblClick: (tree: any, node: any, $event: any) => {
            if (node.hasChildren) {
              TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
            }
          },
          drop: (
            tree: TreeModel,
            node: TreeNode,
            $event: any,
            { from, to }
          ) => {
            // recover 'from' robustly
            from = this.extractFrom(tree, $event, from);

            if (!from || !from.data) {
              return;
            }

            // support both TreeNode shapes and plain data objects
            const fromData = from.data ? from.data : from;
            const toParentData = to && to.parent ? to.parent.data : null;

            // Allow 'laws' and 'regulation' to match each other as equivalent
            const isLawsOrRegulation = (type: any) =>
              type === 'laws' || type === 'regulation';
            if (
              (isLawsOrRegulation(fromData.documentType) &&
                isLawsOrRegulation(toParentData.documentType)) ||
              fromData.documentType === toParentData.documentType ||
              (fromData.documentType && toParentData.documentType === undefined)
            ) {
              // perform the move/copy (let the tree handle clone/move behavior)
              TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });

              // clear the shared last-dragged node after a short delay
              setTimeout(() => this.dragDropService.clearLastNode(), 50);

              this.showAlert(
                `${fromData.filename} ${this.translate.instant(
                  'COPIED_TO'
                )}  ${toParentData.filename}`
              );
            } else {
              if (
                isLawsOrRegulation(fromData.documentType) ||
                isLawsOrRegulation(toParentData.documentType)
              ) {
                this.showAlert(
                  this.translate.instant('MOVE_NOT_ALLOWED_LAWS_REGULATION') ||
                    '"laws" and "regulation" documents can only be moved between each other. Move not allowed to other types.'
                );
              } else {
                this.showAlert(
                  this.translate.instant('MOVE_NOT_ALLOWED_DOC_TYPES') ||
                    'Move not allowed: document types do not match.'
                );
              }
            }
          }
        },
        keys: {
          [KEYS.ENTER]: (tree: any, node: any, $event: any) => {
            node.expand();
          }
        }
      },
      nodeHeight: 24,
      useVirtualScroll: false,
      animateExpand: true,
      animateSpeed: 30,
      animateAcceleration: 1.2
    };

    if (this.allowDrag || this.allowDrop) {
      this.options = this.staticOptions;
    }

    let allData = _.cloneDeep(this.ecplTreeData);
    // data for angular2-tree based on Editmode
    if (this.ecplTreeCheckbox) {
      this.nodes = [];
      this.nodes.push(...this.ecplTreeData);
    } else {
      const activeNodes: any = [];
      allData.forEach((node, i) => {
        const nd = this.getSelectedNodes(node);
        if (nd) {
          activeNodes.push(nd);
        }
      });
      this.nodes = [];
      this.nodes.push(...activeNodes);
    }
  }

  /** find a TreeNode by id (works via API if present; otherwise recursive search) */
  private getNodeByIdFromTree(tree: any, id: string): any | null {
    if (!id) return null;
    try {
      if (tree && typeof tree.getNodeById === 'function')
        return tree.getNodeById(id);
    } catch (e) {}
    if (!tree || !tree.nodes) return null;
    const stack = Array.isArray(tree.nodes) ? [...tree.nodes] : [];
    while (stack.length) {
      const candidate = stack.shift();
      if (!candidate) continue;
      const data = (candidate as any).data || candidate;
      if (data && String(data.id) === String(id)) return candidate;
      const children =
        (candidate as any).children ||
        (candidate as any).nodes ||
        (data && data.nodes);
      if (Array.isArray(children) && children.length) stack.push(...children);
    }
    return null;
  }

  /** Consolidated extraction of `from` (handles TreeNode, event, service fallback, dataTransfer id) */
  private extractFrom(tree: any, $event: any, from: any): any {
    if (from) return from;
    if ($event && $event.draggedNode) return $event.draggedNode;
    if ($event && $event.data)
      return { data: $event.data, node: $event.node || $event.draggedNode };
    const last = this.dragDropService.getLastNode();
    if (last) return { data: last }; // keep same shape as other fallbacks
    try {
      const id =
        $event &&
        $event.dataTransfer &&
        ($event.dataTransfer.getData('text/plain') ||
          $event.dataTransfer.getData('text'));
      if (id) {
        const found = this.getNodeByIdFromTree(tree, id);
        if (found) return found;
      }
    } catch (e) {
      /* ignore getData exceptions */
    }
    return null;
  }

  setSelectedNodes(nodeData: any) {
    const treeModel: TreeModel = this.getTreeModel();
    if (!nodeData.isFolder) {
      const node: TreeNode = treeModel.getNodeById(nodeData.id);
      if (node && nodeData.status === 1) {
        node.setIsSelected(true);
      }
    } else {
      const node: TreeNode = treeModel.getNodeById(nodeData.id);
      if (node && nodeData.isFolder && nodeData.isDefault) {
        node.setIsSelected(true);
      }
      nodeData.nodes.forEach((n: any) => {
        this.setSelectedNodes(n);
      });
    }
  }

  getSelectedNodes(nodeData: any) {
    let selectedNodes: any = {};
    if (nodeData.status === 1) {
      selectedNodes = nodeData;
    } else {
      return null;
    }

    if (nodeData.nodes != null && nodeData.nodes.length > 0) {
      const nodes: any = [];
      nodeData.nodes.forEach((node: any, i: any) => {
        const nd = this.getSelectedNodes(node);
        if (nd) {
          nodes.push(nd);
        }
      });
      selectedNodes['nodes'] = nodes;
    }

    return selectedNodes;
  }

  getFileExtensionFromMimeType(input: string): string | null {
    return this.helperV2Service.getFileExtension(input);
  }

  //#endregion

  //#region file viewer/editors

  humanizeType(mimetype: any) {
    let type = '';
    if (mimetype && typeof mimetype === 'string' && mimetype.includes('?')) {
      mimetype = mimetype.split('?')[0];
    }
    //

    switch (mimetype) {
      case 'xlsx':
      case 'xls':
      case 'csv':
      case 'docx':
      case 'doc':
      case 'rtf':
      case 'ppt':
      case 'pptx':
      case 'csv':
        type = 'Document';
        break;
      case 'png':
      case 'jpg':
      case 'JPG':
      case 'jpeg':
      case 'bmp':
      case 'gif':
      case 'tiff':
        type = 'Image';
        break;
      case 'mp3':
      case 'wav':
        type = 'Audio';
        break;
      case 'avi':
      case 'mp4':
      case '3gpp':
      case 'webm':
      case 'flv':
        type = 'Video';
        break;
      case 'txt':
        type = 'Text';
        break;
      case 'PDF':
      case 'pdf':
        type = 'Pdf';
        break;
      case 'zip':
      case 'rar':
      case '7z':
        type = 'Archive file';
        break;
      default:
        type = 'Article';
        break;
    }

    return type;
  }

  getFileExtension(filename: any) {
    let fileExtension = filename.substr(filename.lastIndexOf('.') + 1);
    if (fileExtension && fileExtension.includes('?')) {
      fileExtension = fileExtension.split('?')[0];
    }
    return fileExtension;
  }

  triggerFalseClick() {
    const el: HTMLElement | null =
      this.hiddenAction.nativeElement.querySelector(
        'a, button.kuba-document-trigger'
      );
    if (el !== null) {
      el.click();
    }
  }

  /**
   * Opens the checklist viewer rendered in the hidden action container.
   * Calls the viewer directly; falls back to the hidden trigger when it is not rendered.
   */
  openChecklistViewer() {
    if (this.checklistViewerRef !== undefined) {
      this.checklistViewerRef.showModal();
    } else {
      this.triggerFalseClick();
    }
  }

  filterNodes(text: string, tree: any) {
    this.filterText = text;

    // If no filter text, show all nodes
    if (!text || text.trim() === '') {
      this.filteredPrimeNodes = this.primeNodes;
      this.cdr.detectChanges();
      return;
    }

    // Perform client-side filtering on the tree nodes
    const filterText = text.toLowerCase().trim();
    this.filteredPrimeNodes = this.filterTreeNodes(this.primeNodes, filterText);
    this.cdr.detectChanges();
  }

  /**
   * Recursively filter tree nodes based on search text
   * A node is included if its filename matches OR any of its descendants match
   */
  private filterTreeNodes(nodes: any[], filterText: string): any[] {
    if (!nodes || nodes.length === 0) return [];

    const result: any[] = [];

    for (const node of nodes) {
      const filename = (node.data?.filename || node.label || '').toLowerCase();
      const nodeMatches = filename.includes(filterText);

      // Recursively filter children
      const filteredChildren = this.filterTreeNodes(
        node.children || [],
        filterText
      );

      if (nodeMatches || filteredChildren.length > 0) {
        // A matching folder keeps its whole subtree, so its files stay visible
        const children = nodeMatches ? node.children || [] : filteredChildren;
        const clonedNode = {
          ...node,
          children,
          expanded: children.length > 0,
          nodes: children // Keep compatibility
        };
        clonedNode.hasChildren = children.length > 0;
        if (clonedNode.data) {
          clonedNode.data = {
            ...clonedNode.data,
            hasChildren: clonedNode.hasChildren
          };
        }
        result.push(clonedNode);
      }
    }

    return result;
  }

  //#endregion

  editClick(node: any) {
    this.ecplNodeOptionsEvent.emit({ data: node, action: 'edit' });
  }
  printClick(node: any) {
    this.ecplNodeOptionsEvent.emit({ data: node, action: 'print' });
  }
  deleteClick(node: any) {
    this.ecplNodeOptionsEvent.emit({ data: node, action: 'delete' });
  }

  // Alert Dialog methods (replaces native browser alert)
  showAlert(message: string): void {
    this.alertDialogMessage = message;
    this.showAlertDialog = true;
  }

  closeAlertDialog(): void {
    this.showAlertDialog = false;
    this.alertDialogMessage = '';
  }
}
